export class FormBase {
  public id: string;
  public title: string;
  public publicTitle: string;
  public introduction: string;
  public confirmationTitle: string;
  public confirmation: string;
  public publicLinkInstructions: string;

  public get displayTitle(): string {
    return this.publicTitle || this.title;
  }

  public isAnyApplication(): boolean {
    return this.title === FormBase.getAnyApplicationTitle();
  }

  public static getAnyApplicationTitle(): string {
    return 'Any Lineup Form';
  }

  public static getMemberApplicationTitle(): string {
    return 'Form';
  }
}
